import React from 'react';

const TracsisLogoGhost = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 154.968 32.458"
			className={className}
		>
			<path
				fill="#fff"
				d="M44.516 9.975h-5.842V6.231h15.942v3.744h-5.815v16.242h-4.285Z"
			/>
			<path
				fill="#fff"
				d="M64.131 19.061h-3.127v7.16H56.76V6.231h9.35c4.166 0 6.713 2.729 6.713 6.443a5.745 5.745 0 0 1-4.377 5.934l4.5 7.609H68.07Zm1.353-9.169h-4.48v5.514h4.467a2.766 2.766 0 1 0 .011-5.514Z"
			/>
			<path
				fill="#fff"
				d="M88.586 22.774h-8.933l-1.256 3.443h-4.67l7.734-19.989h5.333l7.7 19.989h-4.645Zm-7.791-3.687h6.624l-3.3-9.169Z"
			/>
			<path
				fill="#fff"
				d="M93.448 16.242a10.119 10.119 0 0 1 10.49-10.341 9.237 9.237 0 0 1 8.511 4.873l-3.657 1.8a5.474 5.474 0 0 0-4.854-2.894c-3.476 0-6.112 2.788-6.112 6.565s2.637 6.562 6.112 6.562a5.414 5.414 0 0 0 4.854-2.907l3.646 1.768a9.275 9.275 0 0 1-8.511 4.916 10.114 10.114 0 0 1-10.479-10.342Z"
			/>
			<path
				fill="#fff"
				d="M115.867 20.168a8.765 8.765 0 0 0 6.353 2.707c2.336 0 3.476-1.107 3.476-2.247 0-1.5-1.738-2.009-4.061-2.547-3.265-.75-7.461-1.649-7.461-6.112 0-3.327 2.875-6.023 7.58-6.023a11.125 11.125 0 0 1 7.793 2.786l-2.369 3.116a8.535 8.535 0 0 0-5.723-2.187c-1.919 0-2.937.839-2.937 2.038 0 1.354 1.678 1.768 3.985 2.306 3.3.75 7.493 1.741 7.493 6.175 0 3.654-2.607 6.413-8 6.413a11.515 11.515 0 0 1-8.481-3.178Z"
			/>
			<path fill="#fff" d="M132.321 6.231h4.255v19.986h-4.255Z" />
			<path
				fill="#fff"
				d="M140.837 20.168a8.765 8.765 0 0 0 6.353 2.707c2.336 0 3.476-1.107 3.476-2.247 0-1.5-1.738-2.009-4.06-2.547-3.265-.75-7.461-1.649-7.461-6.112 0-3.327 2.875-6.023 7.58-6.023a11.125 11.125 0 0 1 7.793 2.786l-2.369 3.116a8.536 8.536 0 0 0-5.723-2.187c-1.919 0-2.937.839-2.937 2.038 0 1.354 1.678 1.768 3.985 2.306 3.3.75 7.493 1.741 7.493 6.175 0 3.654-2.607 6.413-8 6.413a11.515 11.515 0 0 1-8.481-3.178Z"
			/>
			<path
				fill="#fff"
				d="M18.347 6.072a10.346 10.346 0 0 1 6.521 15.947l4.226 4.223A16.3 16.3 0 0 0 18.347 0Z"
			/>
			<path
				fill="#fff"
				d="M21.974 24.864a10.332 10.332 0 1 1-7.688-18.795V.005a16.288 16.288 0 1 0 11.911 29.092Z"
			/>
		</svg>
	);
};

export default TracsisLogoGhost;
